<template>
  <div class="school-title-bar">
    <img
      src="https://s3.amazonaws.com/images.growmindgrow/school-site/title-left-overlay.svg"
      alt=""
      class="school-title-bar__tape"
    >

    <div class="text-truncate">{{ title }}</div>

    <div class="school-title-bar__right-tape">
      <img src="https://s3.amazonaws.com/images.growmindgrow/school-site/title-right-bar.svg" alt="">
      <img src="https://s3.amazonaws.com/images.growmindgrow/school-site/title-right-bar.svg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'SchoolTitleBar',
  props: {
    title: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_breakpoints.scss";

.school-title-bar {
  font-style: italic;
  font-weight: 600;
  font-size: 20px;
  color: #333333;
  height: 40px;
  line-height: 40px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  position: relative;
  padding: 0 120px 0 150px;
  margin: 12px 0;

  @include for-size(phone-only) {
    padding: 0 80px 0 105px;
  }

  &__tape {
    position: absolute;
    height: 55px;
    top: -7px;
    left: 20px;

    @include for-size(phone-only) {
      left: 7px;
    }
  }

  &__right-tape {
    display: flex;
    position: absolute;
    top: 0;
    right: 40px;

    @include for-size(phone-only) {
      right: 20px;
    }

    img {
      height: 41px;

      &:first-child {
        position: relative;
        right: -16px;
      }
    }
  }
}
</style>
